import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../../../services/api';
import logo from '../../../images/logoaccess.png';
import '../../Login/styles.css';
import IconButton from '../../../components/IconButton';
import { FaExternalLinkAlt, FaLink } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getText, getEventLanguage } from '../../../util/translations';
import Processando from '../../../components/Processando';

export default function CadastroEventoParticipanteContratoEnviado({ match }) {
  const id = match.params.id;
  const [evento, setEvento] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const history = useHistory();
  const { state } = useLocation();
  const idioma = state?.idioma ?? 'both';

  const buscar = () => {
    setIsLoading(true);
    setIsError(false);
    api({
      method: "get",
      action: '/eventoSemLogin/' + id,
    }).then(response => {
      var dadosEvento = response.data.data;
      setEvento(dadosEvento);
      setIsLoading(false);
    }).catch(err => {
      setIsLoading(false);
      setIsError(true);
      toast.error(getText('error', getEventLanguage(evento)) + getText('errorDefault', getEventLanguage(evento)));
    });
  };//buscar

  useEffect(() => { //onload
    buscar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div id="auth" style={
      (evento.cor !== undefined) ? {
        backgroundImage: "none",
        backgroundColor: evento.cor,
      } : {
        backgroundImage: "none",
        backgroundColor: "#AAAAAA",
      }
    }>
      {isLoading && <Processando idioma={idioma} />}
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  {localStorage.getItem('logomarcaEvento') ?
                    <img alt="" src={localStorage.getItem('logomarcaEvento')} height="48" className='mb-4' /> :
                    <img alt="" src={logo} height="48" className='mb-4' />
                  }
                  <p>{getText('contractSent', getEventLanguage(evento))}</p>
                  <p>{getText('thankYou', getEventLanguage(evento))}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
